<template>
  <button class="card-validate" @click="routerPage">
    <div
      class="card-validate-status"
      :class="{ 'card-validate-status--valid': hasProfileIsValid }"
    >
      <img
        v-if="hasProfileIsValid"
        class="img-fluid"
        src="@/assets/img/checked.png"
        alt="icon checked"
        title="icon checked"
      />
      <img
        v-else
        class="img-fluid"
        src="@/assets/img/close-modal.png"
        alt="icon close"
        title="icon close"
      />
      <p class="card-validate-status__text">
        Perfil
        <template v-if="hasProfileIsValid"> Válido </template>
        <template v-else>Inválido</template>
      </p>
    </div>
    <div class="card-validate__div">
      <div class="card-validate__photo">
        <img
          class="img-fluid"
          :src="getPhotoProfile"
          :alt="`foto professional ${professional.data.name}`"
          :title="`foto professional ${professional.data.name}`"
        />
      </div>
      <div class="card-validate__information">
        <h2 class="card-validate__title" v-if="hasCodeNameOrName">
          {{ professional.data?.code_name || professional.data?.name }}
        </h2>
        <h3 class="card-validate__subtitle" v-if="hasProminentProfession">
          {{ professional.data.prominent_profession }}
        </h3>
        <div class="card-validate__document" v-if="hasDocument">
          <img
            class="img-fluid"
            src="@/assets/img/icon-document.png"
            alt="icon document"
            title="icon document"
          />
          <p>
            <span v-if="professional.data.document_name"
              >{{ professional.data.document_name }}: </span
            >{{ professional.data.document_number }}
          </p>
        </div>
      </div>
    </div>
    <div class="card-validate-formation" v-if="hasFormations">
      <h2 class="card-validate-formation__title">Formações:</h2>
      <Formation
        v-for="formation in professional.formations"
        :key="formation.id"
        :formation="formation"
      />
    </div>
  </button>
</template>

<script>
import Formation from "./Formation";

export default {
  props: {
    professional: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasProfessional() {
      return (
        this.professional?.data &&
        Object.keys(this.professional.data).length > 0
      );
    },
    hasProfileIsValid() {
      return this.hasProfessional && this.professional.data?.profile_is_valid;
    },
    hasCodeNameOrName() {
      return (
        this.hasProfessional &&
        (this.professional.data?.code_name || this.professional.data?.name)
      );
    },
    hasProminentProfession() {
      return (
        this.hasProfessional && this.professional.data?.prominent_profession
      );
    },
    hasDocument() {
      return this.hasProfessional && this.professional.data?.document_number;
    },
    hasFormations() {
      return (
        this.professional?.formations &&
        Object.keys(this.professional.formations).length > 0
      );
    },
    getPhotoProfile() {
      return (
        (this.professional?.data?.profile_photo_file_path ??
          this.professional?.data?.photo_url) ||
        require("@/assets/img/image-user-google.png")
      );
    },
  },
  components: {
    Formation,
  },
  methods: {
    routerPage() {
      this.$router.push({
        name: "ValidateProfessionalsDetails",
        params: {
          id: this.professional.data.id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.card-validate {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px 20px 30px 20px;
  background: var(--white);
  border-radius: 20px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  border: 0;
  &-status {
    position: absolute;
    bottom: 10px;
    right: 20px;
    display: flex;
    align-items: center;
    gap: 5px;
    img {
      max-width: 15px;
    }
    &__text {
      font-size: 12px;
      font-family: "Font Semibold";
      color: var(--red-dark);
      margin-bottom: 0;
    }
    &--valid {
      .card-validate-status__text {
        color: var(--green) !important;
      }
    }
  }
  &__div {
    display: flex;
    align-items: center;
    gap: 30px;
    border-bottom: 1px solid var(--gray-1);
    padding-bottom: 10px;
  }
  &__photo {
    margin-bottom: 20px;
    img {
      border-radius: 100%;
      max-width: 60px;
      max-height: 60px;
      object-fit: cover;
    }
  }
  &__information {
    text-align: left;
  }
  &__title {
    font-size: 16px;
    font-family: "Font Semibold";
    color: var(--black);
    margin-bottom: 10px;
  }
  &__subtitle {
    font-size: 14px;
    font-family: "Font Regular";
    color: var(--gray-dark);
  }
  &__document {
    display: flex;
    align-items: center;
    gap: 5px;
    img {
      max-width: 20px;
    }
    p {
      font-size: 12px;
      color: var(--black);
      font-family: "Font Regular";
      margin-bottom: 0;
      span {
        font-family: "Font Semibold";
      }
    }
  }
  &-formation {
    padding-top: 20px;
    text-align: left;
    &__title {
      font-size: 14px;
      font-family: "Font Semibold";
      color: var(--black);
      margin-bottom: 15px;
    }
  }
}
</style>
